import { PencilBaseIcon } from '@tableau/icons/PencilBaseIcon';
import { TrashBaseIcon } from '@tableau/icons/TrashBaseIcon';
import React from 'react';

import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { Messages } from '~src/codegen/Localize';
import { DraftBanner, DraftBannerAction } from '~src/drafts/components/DraftBanner';
import {
  deletePublishedConnectionDraft
} from '~src/publishedConnection/actions/DeletePublishedConnectionDraftReduxAction';
import { editPublishedConnectionDraft } from '~src/publishedConnection/actions/EditPublishedConnectionDraftReduxAction';
import { IPublishedConnectionDraftInfo } from '~src/publishedConnection/models/IPublishedConnectionInfo';

export type PublishedConnectionDraftBannerProps = {
  readonly publishedConnectionDraft: IPublishedConnectionDraftInfo;
};

export function PublishedConnectionDraftBanner(props: PublishedConnectionDraftBannerProps): JSX.Element {
  if (!props.publishedConnectionDraft.luid) {
    return null;
  }

  const handleEditDraft = () => {
      getAppStore().dispatch(editPublishedConnectionDraft(props.publishedConnectionDraft.luid));
  };

  const handleDeleteDraft = () => {
      getAppStore().dispatch(deletePublishedConnectionDraft(props.publishedConnectionDraft.luid));
  };

  const continueEditBannerAction: DraftBannerAction = {
    label: Messages.continueEditing(),
    handleAction: handleEditDraft,
    icon: <PencilBaseIcon size={18} aria-hidden={true}/>,
    testId: 'continue-editing'
  };

  const deleteDraftBannerAction: DraftBannerAction = {
    label: Messages.deleteDraft(),
    handleAction: handleDeleteDraft,
    icon: <TrashBaseIcon size={14} aria-hidden={true}/>,
    testId: 'delete-draft'
  };

  return (
    <DraftBanner
      lastEditDate={props.publishedConnectionDraft.updatedAt}
      draftBannerActions={[continueEditBannerAction, deleteDraftBannerAction]}
      contentTypeName={Messages.virtualConnectionLowerCase()}
    />
  );
}
